export default {
      id: "ic_information_circle-usage",
      viewBox: "0 0 32 32",
      url: "/" + "images/icons.3.109.2.svg#ic_information_circle-usage",
      toString: function () {
        return this.url;
      }
    }